import {
  FormGroupLabel,
  FormRadio,
  FormRadioGroup,
  type FormRadioProps,
  useFormContext,
  VisuallyHidden,
} from "@ariakit/react";
import { themeIds, themes } from "../../domain/theme";
import { atomic } from "../atomic.css";
import { ThemeSwatch } from "../theme/swatch";
import * as css from "./style.css";

export function ThemeField(props: { name: FormRadioProps["name"] }) {
  const form = useFormContext();
  const value = form?.useValue<string>(props.name);

  return (
    <FormRadioGroup>
      <FormGroupLabel
        className={atomic({
          borderBlockEnd: "solid",
          paddingBlockEnd: 6,
          fontWeight: "medium",
        })}
      >
        Theme
      </FormGroupLabel>

      <div className={css.options}>
        {themeIds.map((id) => {
          return (
            <label key={id} className={css.option}>
              <VisuallyHidden>
                <FormRadio name={props.name} value={id} />
                {themes[id].name}
              </VisuallyHidden>

              <ThemeSwatch theme={id} size="100%" hollow={value !== id} />
            </label>
          );
        })}
      </div>
    </FormRadioGroup>
  );
}
